import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__overlay" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "popup__title" }, "Reorder", -1)
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-label__entry" }, "New place", -1)
const _hoisted_6 = { class: "popup__tools" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "popup" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "popup",
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("label", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "form-input --dark",
              ref: "input",
              type: "number",
              min: "1",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transientIndex) = $event)),
              disabled: _ctx.buildingData || _ctx.connectionError,
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeOrder && _ctx.changeOrder(...args)), ["enter"]))
            }, null, 40, _hoisted_4), [
              [_vModelText, _ctx.transientIndex]
            ]),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button",
              disabled: (_ctx.buildingData || _ctx.connectionError),
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeOrder && _ctx.changeOrder(...args)), ["stop"]))
            }, " Update ", 8, _hoisted_7),
            _createElementVNode("button", {
              class: "button --outline",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)), ["stop"]))
            }, "Cancel")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}